/* eslint-disable prefer-promise-reject-errors */
import config from 'src/config';
import { postRequest, putRequest } from 'src/utils/RequestUtil';

// API call to search wallet payments
export const slabSearchApi = function (data) {
    const url = `${config.baseUrl}insurance-slab/search`;
    return postRequest({
        url,
        data,
    });
};

// API call to create a new wallet payment
export const insuranceSlabCreateAPI = function ({ data }) {
    const url = `${config.baseUrl}insurance-slab`;
    return postRequest({
        url,
        data,
    });
};

// API call to update an existing wallet payment
export const insuranceSlabUpdateAPI = function ({ slabId, data }) { 
    const url = `${config.baseUrl}insurance-slab/${slabId}`;
    return putRequest({
        url,
        data,
    });
};


